export enum KpiIndex {
  SystemInputVolume = 0,
  AuthorizedConsumption = 1,
  BilledAuthorizedConsumption = 3,
  BilledMeteredConsumption = 7,
  BilledUnmeteredConsumption = 8,
  RevenueWater = 17,
  UnbilledAuthorizedConsumption = 4,
  UnbilledMeteredConsumption = 9,
  UnbilledUnmeteredConsumption = 10,
  WaterLosses = 2,
  ApparentLosses = 5,
  UnauthorizedConsumption = 11,
  CustomerMeteringInaccuracies = 12,
  DataHandlingErrors = 13,
  RealLosses = 6,
  LeakageOnTransmissionMains = 14,
  LeakageOnDistributionNetwork = 15,
  LeakageAndOverflowsAtUtilitysStorageTanks = 16,
  NonRevenueWater = 18,
}

export enum KpiI18Key {
  SystemInputVolume = 'kpi-0-system-input-volume',
  AuthorizedConsumption = 'kpi-1-authorized-consumption',
  BilledAuthorizedConsumption = 'kpi-3-billed-authorized-consumption',
  BilledMeteredConsumption = 'kpi-7-billed-metered-consumption',
  BilledUnmeteredConsumption = 'kpi-8-billed-unmetered-consumption',
  RevenueWater = 'kpi-17-revenue-water',
  UnbilledAuthorizedConsumption = 'kpi-4-unbilled-authorized-consumption',
  UnbilledMeteredConsumption = 'kpi-9-unbilled-metered-consumption',
  UnbilledUnmeteredConsumption = 'kpi-10-unbilled-unmetered-consumption',
  WaterLosses = 'kpi-2-water-losses',
  ApparentLosses = 'kpi-5-apparent-losses',
  UnauthorizedConsumption = 'kpi-11-unauthorized-consumption',
  CustomerMeteringInaccuracies = 'kpi-12-customer-metering-inaccuracies',
  DataHandlingErrors = 'kpi-13-data-handling-errors',
  RealLosses = 'kpi-6-real-losses',
  LeakageOnTransmissionMains = 'kpi-14-leakage-on-transmission-mains',
  LeakageOnDistributionNetwork = 'kpi-15-leakage-on-distribution-network',
  LeakageAndOverflowsAtUtilitysStorageTanks = 'kpi-16-leakage-and-overflows-at-utilitys-storage-tanks',
  NonRevenueWater = 'kpi-18-non-revenue-water',
}
